import { render, staticRenderFns } from "./OrderCreator.vue?vue&type=template&id=b44bf7fa&scoped=true&"
import script from "./OrderCreator.vue?vue&type=script&lang=js&"
export * from "./OrderCreator.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreator.vue?vue&type=style&index=0&id=b44bf7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44bf7fa",
  null
  
)

export default component.exports